const nameToPath=(name)=>{return name.replace(/\s+/g, '-').toLowerCase();}
export default nameToPath